import { useIntl } from 'react-intl';
import { EmptyStateRadar } from '@rossum/ui';
import { button } from '../../../lib/formaterValues';

type RulesPageEmptyStateProps =
  | {
      variant: 'empty';
      onCreateRule: () => void;
    }
  | {
      variant: 'noResults';
      searchValue: string;
      onClearSearch: () => void;
    }
  | {
      variant: 'noFilterResults';
      onClearFilters: () => void;
    };

export const RulesPageEmptyState = (props: RulesPageEmptyStateProps) => {
  const intl = useIntl();

  if (props.variant === 'empty') {
    return (
      <EmptyStateRadar
        title={intl.formatMessage({
          id: 'features.queueSettings.rules.list.empty.title',
        })}
        description={intl.formatMessage(
          { id: 'features.queueSettings.rules.list.empty.description' },
          { link: button(props.onCreateRule) }
        )}
      />
    );
  }

  if (props.variant === 'noResults') {
    return (
      <EmptyStateRadar
        title={intl.formatMessage(
          { id: 'features.queueSettings.rules.list.noResults.title' },
          { search: props.searchValue }
        )}
        description={intl.formatMessage(
          { id: 'features.queueSettings.rules.list.noResults.description' },
          { button: button(props.onClearSearch) }
        )}
      />
    );
  }

  return (
    <EmptyStateRadar
      title={intl.formatMessage({
        id: 'features.queueSettings.rules.list.noFilterResults.title',
      })}
      description={intl.formatMessage(
        { id: 'features.queueSettings.rules.list.noFilterResults.description' },
        { button: button(props.onClearFilters) }
      )}
    />
  );
};
